import {
  Input, Component, AfterViewInit, ElementRef,
  ViewEncapsulation, Renderer2
} from '@angular/core';
import { FormbirdInjectorService } from 'formbird-services';
import { DocumentData, FormDocument, FormTemplate } from '@formbird/types';

@Component({
  selector: 'sc-lazy-loader',
  templateUrl: './lazy-loader.component.html',
  styleUrls: ['./lazy-loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LazyLoaderComponent implements AfterViewInit {

  @Input() formParameters: any;
  @Input() documentData: DocumentData;
  @Input() key: number;
  @Input() account: any;

  @Input() document: FormDocument;
  @Input() fieldValue: any;
  @Input() template: FormTemplate;
  @Input() fieldName: string;
  @Input() message: string;
  @Input() componentDefinition: any;

  private scrollElement: any;

  componentService: any;
  componentLoaded = false;
  scrolled = false;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private formbirdInjectorService: FormbirdInjectorService) {
    this.componentService = this.formbirdInjectorService.get('ComponentService');
  }

  ngAfterViewInit() {
    this.scrollElement = document.querySelector('#ft-sidenav-content');
    this.scrollElement.addEventListener('scroll', () => {
      this.loadAndDisplayIfScrolled();
    });

    setTimeout(() => {
      this.loadAndDisplayIfScrolled();
    }, 3000);
  }

  private loadAndDisplayIfScrolled() {
    const scrollElementHeight = this.scrollElement.getBoundingClientRect().height;
    const elementTop = this.el.nativeElement.getBoundingClientRect().top;
    const offset = 100;

    if ((elementTop - offset) <= scrollElementHeight) {
      this.scrolled = true;
    }

    if (this.scrolled
      && !this.componentLoaded
      && this.componentDefinition
      && this.componentDefinition.lazyComponentName) {
        this.componentLoaded = true;
          
      const componentName = this.componentDefinition.lazyComponentName;
      this.componentService
        .loadComponentDocAndVendorLibs(componentName)
        .then(() => {
          this.renderComponent(componentName);
        })
        .catch((err) => {
          console.log(`Error loading component: ${componentName} `, err);
          this.renderComponent('ft-component-not-found');
        });
    }
  }

  renderComponent(componentName) {
    this.componentDefinition.componentName = componentName;

    const customElement = this.renderer.createElement(componentName);

    customElement.componentDefinition = this.componentDefinition;
    customElement.document = this.document;
    customElement.template = this.template;
    customElement.formParameters = this.formParameters;
    customElement.key = this.key;
    customElement.account = this.account;
    customElement.fieldName = this.fieldName;
    customElement.fieldValue = this.fieldValue;

    this.renderer.insertBefore(this.el.nativeElement, customElement, this.el.nativeElement.firstChild);
  }
}
